// extracted by mini-css-extract-plugin
module.exports = {"container":"scholarshipMenuRight_container__BZ5E_","renewal_tag":"scholarshipMenuRight_renewal_tag__3rAMb"};